exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo-management[data-v-9271bd0a] {\n  position: relative;\n}\n.photo-management .icon[data-v-9271bd0a] {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  top: 50%;\n  margin-top: -25px;\n  left: 50%;\n  margin-left: -18px;\n  color: #111;\n  display: none;\n}\n.photo-management:hover .profile-img[data-v-9271bd0a] {\n  opacity: 0.3;\n}\n.photo-management:hover .icon[data-v-9271bd0a] {\n  display: block;\n}\n.clickable[data-v-9271bd0a] {\n  cursor: pointer;\n}", ""]);

// exports
